import type { Loading } from "@/lib/loading"

export const processIsReady = (
  {
    loading,
  }: {
    loading: Loading.ContextData
  },
  processId: Loading.ProcessId
) => {
  return !loading.processes[processId].loading
}
